export default __webpack_public_path__ + "static/media/no-prospect-activity.4269d49c.svg";